import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { recoverFromChunkLoadError } from './app/chunk-load-recovery';

// AG Grid
import { LicenseManager } from '@ag-grid-enterprise/core';
environment.agGridLicenseKey && LicenseManager.setLicenseKey(environment.agGridLicenseKey);

import { ModuleRegistry } from '@ag-grid-community/core'; // @ag-grid-community/core will always be implicitly available
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  SetFilterModule,
]);
// ^

if (environment.production) {
  enableProdMode();
}

window.addEventListener('error', event => {
  if (recoverFromChunkLoadError(event.error ?? event.message)) {
    event.preventDefault();
  }
});

window.addEventListener('unhandledrejection', event => {
  if (recoverFromChunkLoadError(event.reason)) {
    event.preventDefault();
  }
});

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((error) => {
    if (!recoverFromChunkLoadError(error)) {
      console.error(error);
    }
  });
